// extracted by mini-css-extract-plugin
module.exports = {"calendarDummyImg":"styles_calendarDummyImg__2ko8o","btnWrapper":"styles_btnWrapper__3a3ZW","link":"styles_link__3JzZl"};